<button
    ds-button
    msThemedButton
    size="small"
    wrapText="true"
    [kind]="buttonConfig.kind"
    [themeKind]="buttonThemeKind"
    [themeVariant]="buttonThemeVariant"
    [variant]="buttonConfig.variant"
    (click)="click($event)">
    {{ title || siteCore.betBuilderEntainUI.messages?.EditPickButton }}
    @if ((!hideIcon && !isEpcotEnabled) || editIconButtonOverride) {
        <vn-icon slot="end" size="10" name="theme-edit"></vn-icon>
    }
</button>
<ng-template #header>
    <ms-betbuilder-overlay-header
        [eventName]="pick.eventName.name"
        [eventStartDate]="eventStartDate"
        [sportId]="pick.sportId"
        [leagueId]="pick.competitionId"
        [eventId]="pick.eventId"
        [eventParticipants]="participants"
        [eventViewType]="eventViewType"></ms-betbuilder-overlay-header>
</ng-template>
